export class RoutingIDs {

    public static MENUE_START = 0;
    public static MENUE_RECHTEVERWALTUNG = 1;
    public static MENUE_DATENVERWALTUNG = 2;
    public static MENUE_KENNZAHLEN_DATENBANK = 3;
    public static MENUE_UNTERNEHMENSDATENBANK = 4;
    public static MENUE_PV_TOOL = 5;
    public static MENUE_KOMMUNIKATION = 6;
    public static MENUE_STATISTIK = 7;
    public static MENUE_VERSIONSHISTORIE = 8;
    public static MENUE_FEEDBACK_FAKTOREN = 9;
    public static MENUE_TOOL_PRUEFUNG = 10;
    public static MENUE_KONTAKT = 11;
    public static MENUE_PREVIEW_TEST = 12;

    public static TABS_DATENVERWALTUNG = 'tabDatenverwaltung';
    public static TABS_DATENVERWALTUNG_BEREICHSSTRUKTUR = 'tabDatenverwaltungBereichsstruktur';
    public static TABS_DATENVERWALTUNG_ENERGIE = 'tabDatenverwaltungEnergie';
    public static TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER = 'tabDatenverwaltungInhalteSupportParameter';
    public static TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK = 'tabDatenverwaltungCo2Fussabdruck';
    public static TABS_DATENVERWALTUNG_KATALOGE = 'tabDatenverwaltungKataloge';
    public static TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT = 'tabDatenverwaltungMehrsprachigkeit';
    public static TABS_KENNZAHLEN_DATENBANK = 'tabKennzahlenDatenbank';
    public static TABS_UNTERNEHMENSDATENBANK = 'tabUnternehmensdatenbank';
    public static TABS_UNTERNEHMENSDATENBANK_VERBAENDE = 'tabUnternehmensdatenbankVerbaende';
    public static TABS_RECHTEVERWALTUNG = 'tabRechteverwaltung';
    public static TABS_PV_TOOL = 'tabPvTool';
    public static TABS_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN = 'tabPvToolErzeugungsdatenLastdaten';
    public static TABS_KOMMUNIKATION = 'tabKommunikation';
    public static TABS_STATISTIK = 'tabStatistik';

    // Level 1
    public static TAB_DATENVERWALTUNG_BEREICHSSTRUKTUR = 0;
    public static TAB_DATENVERWALTUNG_ENERGIE = 1;
    public static TAB_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER = 2;
    public static TAB_DATENVERWALTUNG_CO2_FUSSABDRUCK = 3;
    public static TAB_DATENVERWALTUNG_KATALOGE = 4;
    public static TAB_DATENVERWALTUNG_MEHRSPRACHIGKEIT = 5;
    public static TAB_KENNZAHLEN_DATENBANK_KENNZAHLEN_DEFINITION = 0;
    public static TAB_KENNZAHLEN_DATENBANK_IMPORT_INITIAL = 1;
    public static TAB_KENNZAHLEN_DATENBANK_IMPORT_E_TOOL = 2;
    public static TAB_KENNZAHLEN_DATENBANK_DATEN_ROH = 3;
    public static TAB_KENNZAHLEN_DATENBANK_DATEN_AGGREGIERT = 4;
    public static TAB_KENNZAHLEN_DATENBANK_DATENBANK_EXPORT = 5;
    public static TAB_UNTERNEHMENSDATENBANK_KONTAKTE = 0;
    public static TAB_UNTERNEHMENSDATENBANK_UNTERNEHMEN = 1;
    public static TAB_UNTERNEHMENSDATENBANK_REGISTRIERUNGEN = 2;
    public static TAB_UNTERNEHMENSDATENBANK_BERATER = 3;
    public static TAB_UNTERNEHMENSDATENBANK_BERATER_WEITERE = 4;
    public static TAB_UNTERNEHMENSDATENBANK_BERATERZUORDNUNG = 5;
    public static TAB_UNTERNEHMENSDATENBANK_HWK_LISTE = 6;
    public static TAB_UNTERNEHMENSDATENBANK_VERBAENDE = 7;
    public static TAB_UNTERNEHMENSDATENBANK_SCHULUNG = 8;
    public static TAB_UNTERNEHMENSDATENBANK_MANDANTEN_BENUTZER = 9;
    public static TAB_RECHTEVERWALTUNG_BENUTZER = 0;
    public static TAB_RECHTEVERWALTUNG_RECHTE = 1;
    public static TAB_RECHTEVERWALTUNG_GRUPPEN = 2;
    public static TAB_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN = 0;
    public static TAB_PV_TOOL_EEG_VERGUETUNG = 1;
    public static TAB_PV_TOOL_PARAMETER = 2;
    public static TAB_KOMMUNIKATION_INFO_MAIL = 0;
    public static TAB_KOMMUNIKATION_AKTUELLE_NACHRICHTEN = 1;
    public static TAB_KOMMUNIKATION_AKTUELLE_TERMINE = 2;
    public static TAB_STATISTIK_HANDWERK = 0;
    public static TAB_STATISTIK_KULTUR = 1;
    public static TAB_STATISTIK_SONSTIGE = 2;
    public static TAB_STATISTIK_SYSTEM = 3;

    // Level 2
    public static TAB_BEREICHSSTRUKTUR_BEREICHE = 0;
    public static TAB_BEREICHSSTRUKTUR_GEWERKE_DEFINITION = 1;
    public static TAB_BEREICHSSTRUKTUR_WZ_DEFINITION = 2;
    public static TAB_BEREICHSSTRUKTUR_GEWERKE_GRUPPE = 3;
    public static TAB_ENERGIE_ENERGIESTEUER = 0;
    public static TAB_ENERGIE_HEIZWERTE = 1;
    public static TAB_ENERGIE_QUELLEN = 2;
    public static TAB_ENERGIE_GRADTAGSZAHLEN = 3;
    public static TAB_ENERGIE_GRADTAGSZAHLEN_ORTE = 4;
    public static TAB_INHALTE_SUPPORT_PARAMETER_FAQ = 0;
    public static TAB_INHALTE_SUPPORT_PARAMETER_GLOSSAR = 1;
    public static TAB_INHALTE_SUPPORT_PARAMETER_GLOSSAR_ZUORDNUNG = 2;
    public static TAB_INHALTE_SUPPORT_PARAMETER_SYSTEMTEXTE = 3;
    public static TAB_INHALTE_SUPPORT_PARAMETER_SYSTEMTEXTE_ZUORDNUNG = 4;
    public static TAB_INHALTE_SUPPORT_PARAMETER_ONLINE_HILFE = 5;
    public static TAB_INHALTE_SUPPORT_PARAMETER_BUNDESLAENDER = 6;
    public static TAB_INHALTE_SUPPORT_PARAMETER_ZERTIFIZIERUNGSOPTIONEN = 7;
    public static TAB_INHALTE_SUPPORT_PARAMETER_ZERTIFIZIERUNG_ZUORDNUNG = 8;
    public static TAB_INHALTE_SUPPORT_PARAMETER_FOERDERUNG = 9;
    public static TAB_INHALTE_SUPPORT_PARAMETER_FOERDERUNG_ZUORDNUNG = 10;
    public static TAB_INHALTE_SUPPORT_PARAMETER_PARTNER = 11;
    public static TAB_INHALTE_SUPPORT_PARAMETER_PARTNER_ZUORDNUNG = 12;
    public static TAB_INHALTE_SUPPORT_PARAMETER_SYSTEMPARAMETER = 13;
    public static TAB_INHALTE_SUPPORT_PARAMETER_DATEIEN = 14;
    public static TAB_INHALTE_SUPPORT_PARAMETER_MEDIEN = 15;
    public static TAB_INHALTE_SUPPORT_PARAMETER_PLAUSIBILISIERUNG = 16;
    public static TAB_INHALTE_SUPPORT_PARAMETER_KONTAKT_FAQ = 17;
    public static TAB_INHALTE_SUPPORT_PARAMETER_KONTAKT_FAQ_ZUORDNUNG = 18;
    public static TAB_CO2_FUSSABDRUCK_FAKTOREN_KLIMAGASE = 0;
    public static TAB_CO2_FUSSABDRUCK_FAKTOREN_BRENNSTOFFE = 1;
    public static TAB_CO2_FUSSABDRUCK_MATERIALIEN = 2;
    public static TAB_CO2_FUSSABDRUCK_GUETER = 3;
    public static TAB_CO2_FUSSABDRUCK_TRANSPORTE = 4;
    public static TAB_CO2_FUSSABDRUCK_ABFAELLE = 5;
    public static TAB_CO2_FUSSABDRUCK_REISEN_ENTFERNUNG = 6;
    public static TAB_CO2_FUSSABDRUCK_REISEN_UEBERNACHTUNG = 7;
    public static TAB_CO2_FUSSABDRUCK_PENDELN = 8;
    public static TAB_CO2_FUSSABDRUCK_UNTERKUNFT = 9;
    public static TAB_CO2_FUSSABDRUCK_ANGEMIETETE_RAEUMLICHKEITEN = 10;
    public static TAB_CO2_FUSSABDRUCK_ANGEMIETETE_FAHRZEUGE = 11;
    public static TAB_CO2_FUSSABDRUCK_DATEIABLAGE = 12;
    public static TAB_MEHRSPRACHIGKEIT_NAVIGATION = 0;
    public static TAB_MEHRSPRACHIGKEIT_FORMULARE = 1;
    public static TAB_MEHRSPRACHIGKEIT_STATISCHE_INHALTE = 2;
    public static TAB_MEHRSPRACHIGKEIT_FAQ = 3;
    public static TAB_MEHRSPRACHIGKEIT_GLOSSAR = 4;
    public static TAB_MEHRSPRACHIGKEIT_SYSTEMTEXTE = 5;
    public static TAB_MEHRSPRACHIGKEIT_ONLINE_HILFE = 6;
    public static TAB_VERBAENDE_VERBANDSLISTE = 0;
    public static TAB_VERBAENDE_VERBANDSZUORDNUNG = 1;
    public static TAB_ERZEUGUNGSDATEN_LASTDATEN_TABELLE = 0;
    public static TAB_ERZEUGUNGSDATEN_LASTDATEN_IMPORT = 1;

    // Level 0
    public static ROUTE_START = {
        selectedMenu: RoutingIDs.MENUE_START
    };
    public static ROUTE_DATENVERWALTUNG = {
        selectedMenu: RoutingIDs.MENUE_DATENVERWALTUNG,
        hasSubs: true
    };
    public static ROUTE_KENNZAHLEN_DATENBANK = {
        selectedMenu: RoutingIDs.MENUE_KENNZAHLEN_DATENBANK,
        hasSubs: true
    };
    public static ROUTE_UNTERNEHMENSDATENBANK = {
        selectedMenu: RoutingIDs.MENUE_UNTERNEHMENSDATENBANK,
        hasSubs: true
    };
    public static ROUTE_RECHTEVERWALTUNG = {
        selectedMenu: RoutingIDs.MENUE_RECHTEVERWALTUNG,
        hasSubs: true
    };
    public static ROUTE_PV_TOOL = {
        selectedMenu: RoutingIDs.MENUE_PV_TOOL,
        hasSubs: true
    };
    public static ROUTE_KOMMUNIKATION = {
        selectedMenu: RoutingIDs.MENUE_KOMMUNIKATION
    };
    public static ROUTE_STATISTIK = {
        selectedMenu: RoutingIDs.MENUE_STATISTIK,
        hasSubs: true
    };
    public static ROUTE_VERSIONSHISTORIE = {
        selectedMenu: RoutingIDs.MENUE_VERSIONSHISTORIE
    };
    public static ROUTE_FEEDBACK_FAKTOREN = {
        selectedMenu: RoutingIDs.MENUE_FEEDBACK_FAKTOREN
    };
    public static ROUTE_TOOL_PRUEFUNG = {
        selectedMenu: RoutingIDs.MENUE_TOOL_PRUEFUNG
    };
    public static ROUTE_KONTAKT = {
        selectedMenu: RoutingIDs.MENUE_KONTAKT
    };
    public static ROUTE_PREVIEW_TEST = {
        selectedMenu: RoutingIDs.MENUE_PREVIEW_TEST
    };
    // Level 1
    public static ROUTE_DATENVERWALTUNG_BEREICHSSTRUKTUR = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG,
        [RoutingIDs.TABS_DATENVERWALTUNG]: RoutingIDs.TAB_DATENVERWALTUNG_BEREICHSSTRUKTUR,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG
    };
    public static ROUTE_DATENVERWALTUNG_ENERGIE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG,
        [RoutingIDs.TABS_DATENVERWALTUNG]: RoutingIDs.TAB_DATENVERWALTUNG_ENERGIE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG
    };
    public static ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG,
        [RoutingIDs.TABS_DATENVERWALTUNG]: RoutingIDs.TAB_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG
    };
    public static ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG,
        [RoutingIDs.TABS_DATENVERWALTUNG]: RoutingIDs.TAB_DATENVERWALTUNG_CO2_FUSSABDRUCK,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG
    };
    public static ROUTE_DATENVERWALTUNG_KATALOGE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG,
        [RoutingIDs.TABS_DATENVERWALTUNG]: RoutingIDs.TAB_DATENVERWALTUNG_KATALOGE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG
    };
    public static ROUTE_DATENVERWALTUNG_MEHRSPRACHIGKEIT = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG,
        [RoutingIDs.TABS_DATENVERWALTUNG]: RoutingIDs.TAB_DATENVERWALTUNG_MEHRSPRACHIGKEIT,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG
    };
    public static ROUTE_KENNZAHLEN_DATENBANK_KENNZAHLEN_DEFINITION = {
        ...RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK, hasSubs: false,
        [RoutingIDs.TABS_KENNZAHLEN_DATENBANK]: RoutingIDs.TAB_KENNZAHLEN_DATENBANK_KENNZAHLEN_DEFINITION,
        terminateOn: RoutingIDs.TABS_KENNZAHLEN_DATENBANK
    };
    public static ROUTE_KENNZAHLEN_DATENBANK_IMPORT_INITIAL = {
        ...RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK, hasSubs: false,
        [RoutingIDs.TABS_KENNZAHLEN_DATENBANK]: RoutingIDs.TAB_KENNZAHLEN_DATENBANK_IMPORT_INITIAL,
        terminateOn: RoutingIDs.TABS_KENNZAHLEN_DATENBANK
    };
    public static ROUTE_KENNZAHLEN_DATENBANK_IMPORT_E_TOOL = {
        ...RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK, hasSubs: false,
        [RoutingIDs.TABS_KENNZAHLEN_DATENBANK]: RoutingIDs.TAB_KENNZAHLEN_DATENBANK_IMPORT_E_TOOL,
        terminateOn: RoutingIDs.TABS_KENNZAHLEN_DATENBANK
    };
    public static ROUTE_KENNZAHLEN_DATENBANK_DATEN_ROH = {
        ...RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK, hasSubs: false,
        [RoutingIDs.TABS_KENNZAHLEN_DATENBANK]: RoutingIDs.TAB_KENNZAHLEN_DATENBANK_DATEN_ROH,
        terminateOn: RoutingIDs.TABS_KENNZAHLEN_DATENBANK
    };
    public static ROUTE_KENNZAHLEN_DATENBANK_DATEN_AGGREGIERT = {
        ...RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK, hasSubs: false,
        [RoutingIDs.TABS_KENNZAHLEN_DATENBANK]: RoutingIDs.TAB_KENNZAHLEN_DATENBANK_DATEN_AGGREGIERT,
        terminateOn: RoutingIDs.TABS_KENNZAHLEN_DATENBANK
    };
    public static ROUTE_KENNZAHLEN_DATENBANK_DATENBANK_EXPORT = {
        ...RoutingIDs.ROUTE_KENNZAHLEN_DATENBANK, hasSubs: false,
        [RoutingIDs.TABS_KENNZAHLEN_DATENBANK]: RoutingIDs.TAB_KENNZAHLEN_DATENBANK_DATENBANK_EXPORT,
        terminateOn: RoutingIDs.TABS_KENNZAHLEN_DATENBANK
    };
    public static ROUTE_UNTERNEHMENSDATENBANK_KONTAKTE = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK, hasSubs: false,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK]: RoutingIDs.TAB_UNTERNEHMENSDATENBANK_KONTAKTE,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK
    };
    public static ROUTE_UNTERNEHMENSDATENBANK_UNTERNEHMEN = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK, hasSubs: false,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK]: RoutingIDs.TAB_UNTERNEHMENSDATENBANK_UNTERNEHMEN,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK
    };
    public static ROUTE_UNTERNEHMENSDATENBANK_REGISTRIERUNGEN = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK, hasSubs: false,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK]: RoutingIDs.TAB_UNTERNEHMENSDATENBANK_REGISTRIERUNGEN,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK
    };
    public static ROUTE_UNTERNEHMENSDATENBANK_BERATER = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK, hasSubs: false,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK]: RoutingIDs.TAB_UNTERNEHMENSDATENBANK_BERATER,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK
    };
    public static ROUTE_UNTERNEHMENSDATENBANK_BERATER_WEITERE = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK, hasSubs: false,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK]: RoutingIDs.TAB_UNTERNEHMENSDATENBANK_BERATER_WEITERE,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK
    };
    public static ROUTE_UNTERNEHMENSDATENBANK_BERATERZUORDNUNG = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK, hasSubs: false,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK]: RoutingIDs.TAB_UNTERNEHMENSDATENBANK_BERATERZUORDNUNG,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK
    };
    public static ROUTE_UNTERNEHMENSDATENBANK_HWK_LISTE = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK, hasSubs: false,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK]: RoutingIDs.TAB_UNTERNEHMENSDATENBANK_HWK_LISTE,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK
    };
    public static ROUTE_UNTERNEHMENSDATENBANK_VERBAENDE = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK]: RoutingIDs.TAB_UNTERNEHMENSDATENBANK_VERBAENDE,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK
    };
    public static ROUTE_UNTERNEHMENSDATENBANK_SCHULUNG = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK, hasSubs: false,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK]: RoutingIDs.TAB_UNTERNEHMENSDATENBANK_SCHULUNG,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK
    };
    public static ROUTE_UNTERNEHMENSDATENBANK_MANDANTEN_BENUTZER = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK, hasSubs: false,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK]: RoutingIDs.TAB_UNTERNEHMENSDATENBANK_MANDANTEN_BENUTZER,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK
    };
    public static ROUTE_RECHTEVERWALTUNG_BENUTZER = {
        ...RoutingIDs.ROUTE_RECHTEVERWALTUNG, hasSubs: false,
        [RoutingIDs.TABS_RECHTEVERWALTUNG]: RoutingIDs.TAB_RECHTEVERWALTUNG_BENUTZER,
        terminateOn: RoutingIDs.TABS_RECHTEVERWALTUNG
    };
    public static ROUTE_RECHTEVERWALTUNG_RECHTE = {
        ...RoutingIDs.ROUTE_RECHTEVERWALTUNG, hasSubs: false,
        [RoutingIDs.TABS_RECHTEVERWALTUNG]: RoutingIDs.TAB_RECHTEVERWALTUNG_RECHTE,
        terminateOn: RoutingIDs.TABS_RECHTEVERWALTUNG
    };
    public static ROUTE_RECHTEVERWALTUNG_GRUPPEN = {
        ...RoutingIDs.ROUTE_RECHTEVERWALTUNG, hasSubs: false,
        [RoutingIDs.TABS_RECHTEVERWALTUNG]: RoutingIDs.TAB_RECHTEVERWALTUNG_GRUPPEN,
        terminateOn: RoutingIDs.TABS_RECHTEVERWALTUNG
    };
    public static ROUTE_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN = {
        ...RoutingIDs.ROUTE_PV_TOOL,
        [RoutingIDs.TABS_PV_TOOL]: RoutingIDs.TAB_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN,
        terminateOn: RoutingIDs.TABS_PV_TOOL
    };
    public static ROUTE_PV_TOOL_EEG_VERGUETUNG = {
        ...RoutingIDs.ROUTE_PV_TOOL, hasSubs: false,
        [RoutingIDs.TABS_PV_TOOL]: RoutingIDs.TAB_PV_TOOL_EEG_VERGUETUNG,
        terminateOn: RoutingIDs.TABS_PV_TOOL
    };
    public static ROUTE_PV_TOOL_PARAMETER = {
        ...RoutingIDs.ROUTE_PV_TOOL, hasSubs: false,
        [RoutingIDs.TABS_PV_TOOL]: RoutingIDs.TAB_PV_TOOL_PARAMETER,
        terminateOn: RoutingIDs.TABS_PV_TOOL
    };
    public static ROUTE_KOMMUNIKATION_INFO_MAIL = {
        ...RoutingIDs.ROUTE_KOMMUNIKATION, hasSubs: false,
        [RoutingIDs.TABS_KOMMUNIKATION]: RoutingIDs.TAB_KOMMUNIKATION_INFO_MAIL,
        terminateOn: RoutingIDs.TABS_KOMMUNIKATION
    };
    public static ROUTE_KOMMUNIKATION_AKTUELLE_NACHRICHTEN = {
        ...RoutingIDs.ROUTE_KOMMUNIKATION, hasSubs: false,
        [RoutingIDs.TABS_KOMMUNIKATION]: RoutingIDs.TAB_KOMMUNIKATION_AKTUELLE_NACHRICHTEN,
        terminateOn: RoutingIDs.TABS_KOMMUNIKATION
    };
    public static ROUTE_KOMMUNIKATION_AKTUELLE_TERMINE = {
        ...RoutingIDs.ROUTE_KOMMUNIKATION, hasSubs: false,
        [RoutingIDs.TABS_KOMMUNIKATION]: RoutingIDs.TAB_KOMMUNIKATION_AKTUELLE_TERMINE,
        terminateOn: RoutingIDs.TABS_KOMMUNIKATION
    };
    public static ROUTE_STATISTIK_HANDWERK = {
        ...RoutingIDs.ROUTE_STATISTIK, hasSubs: false,
        [RoutingIDs.TABS_STATISTIK]: RoutingIDs.TAB_STATISTIK_HANDWERK,
        terminateOn: RoutingIDs.TABS_STATISTIK
    };
    public static ROUTE_STATISTIK_KULTUR = {
        ...RoutingIDs.ROUTE_STATISTIK, hasSubs: false,
        [RoutingIDs.TABS_STATISTIK]: RoutingIDs.TAB_STATISTIK_KULTUR,
        terminateOn: RoutingIDs.TABS_STATISTIK
    };
    public static ROUTE_STATISTIK_SONSTIGE = {
        ...RoutingIDs.ROUTE_STATISTIK, hasSubs: false,
        [RoutingIDs.TABS_STATISTIK]: RoutingIDs.TAB_STATISTIK_SONSTIGE,
        terminateOn: RoutingIDs.TABS_STATISTIK
    };
    public static ROUTE_STATISTIK_SYSTEM = {
        ...RoutingIDs.ROUTE_STATISTIK, hasSubs: false,
        [RoutingIDs.TABS_STATISTIK]: RoutingIDs.TAB_STATISTIK_SYSTEM,
        terminateOn: RoutingIDs.TABS_STATISTIK
    };
    // Level 2
    public static ROUTE_BEREICHSSTRUKTUR_BEREICHE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_BEREICHSSTRUKTUR, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_BEREICHSSTRUKTUR]: RoutingIDs.TAB_BEREICHSSTRUKTUR_BEREICHE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_BEREICHSSTRUKTUR
    };
    public static ROUTE_BEREICHSSTRUKTUR_GEWERKE_DEFINITION = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_BEREICHSSTRUKTUR, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_BEREICHSSTRUKTUR]: RoutingIDs.TAB_BEREICHSSTRUKTUR_GEWERKE_DEFINITION,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_BEREICHSSTRUKTUR
    };
    public static ROUTE_BEREICHSSTRUKTUR_WZ_DEFINITION = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_BEREICHSSTRUKTUR, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_BEREICHSSTRUKTUR]: RoutingIDs.TAB_BEREICHSSTRUKTUR_WZ_DEFINITION,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_BEREICHSSTRUKTUR
    };
    public static ROUTE_BEREICHSSTRUKTUR_GEWERKE_GRUPPE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_BEREICHSSTRUKTUR, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_BEREICHSSTRUKTUR]: RoutingIDs.TAB_BEREICHSSTRUKTUR_GEWERKE_GRUPPE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_BEREICHSSTRUKTUR
    };
    public static ROUTE_ENERGIE_ENERGIESTEUER = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_ENERGIE, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_ENERGIE]: RoutingIDs.TAB_ENERGIE_ENERGIESTEUER,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_ENERGIE
    };
    public static ROUTE_ENERGIE_HEIZWERTE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_ENERGIE, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_ENERGIE]: RoutingIDs.TAB_ENERGIE_HEIZWERTE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_ENERGIE
    };
    public static ROUTE_ENERGIE_QUELLEN = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_ENERGIE, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_ENERGIE]: RoutingIDs.TAB_ENERGIE_QUELLEN,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_ENERGIE
    };
    public static ROUTE_ENERGIE_GRADTAGSZAHLEN = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_ENERGIE, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_ENERGIE]: RoutingIDs.TAB_ENERGIE_GRADTAGSZAHLEN,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_ENERGIE
    };
    public static ROUTE_ENERGIE_GRADTAGSZAHLEN_ORTE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_ENERGIE, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_ENERGIE]: RoutingIDs.TAB_ENERGIE_GRADTAGSZAHLEN_ORTE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_ENERGIE
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_FAQ = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_FAQ,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_GLOSSAR = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_GLOSSAR,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_GLOSSAR_ZUORDNUNG = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_GLOSSAR_ZUORDNUNG,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_SYSTEMTEXTE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_SYSTEMTEXTE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_SYSTEMTEXTE_ZUORDNUNG = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_SYSTEMTEXTE_ZUORDNUNG,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_ONLINE_HILFE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_ONLINE_HILFE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_BUNDESLAENDER = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_BUNDESLAENDER,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_ZERTIFIZIERUNGSOPTIONEN = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_ZERTIFIZIERUNGSOPTIONEN,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_ZERTIFIZIERUNG_ZUORDNUNG = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_ZERTIFIZIERUNG_ZUORDNUNG,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_FOERDERUNG = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_FOERDERUNG,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_FOERDERUNG_ZUORDNUNG = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_FOERDERUNG_ZUORDNUNG,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_PARTNER = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_PARTNER,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_PARTNER_ZUORDNUNG = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_PARTNER_ZUORDNUNG,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_SYSTEMPARAMETER = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_SYSTEMPARAMETER,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_DATEIEN = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_DATEIEN,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_MEDIEN = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_MEDIEN,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_PLAUSIBILISIERUNG = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_PLAUSIBILISIERUNG,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_KONTAKT_FAQ = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_KONTAKT_FAQ,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_INHALTE_SUPPORT_PARAMETER_KONTAKT_FAQ_ZUORDNUNG = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER]: RoutingIDs.TAB_INHALTE_SUPPORT_PARAMETER_KONTAKT_FAQ_ZUORDNUNG,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_INHALTE_SUPPORT_PARAMETER
    };
    public static ROUTE_CO2_FUSSABDRUCK_FAKTOREN_KLIMAGASE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_FAKTOREN_KLIMAGASE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_FAKTOREN_BRENNSTOFFE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_FAKTOREN_BRENNSTOFFE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_MATERIALIEN = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_MATERIALIEN,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_GUETER = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_GUETER,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_TRANSPORTE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_TRANSPORTE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_ABFAELLE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_ABFAELLE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_REISEN_ENTFERNUNG = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_REISEN_ENTFERNUNG,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_REISEN_UEBERNACHTUNG = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_REISEN_UEBERNACHTUNG,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_PENDELN = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_PENDELN,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_UNTERKUNFT = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_UNTERKUNFT,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_ANGEMIETETE_RAEUMLICHKEITEN = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_ANGEMIETETE_RAEUMLICHKEITEN,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_ANGEMIETETE_FAHRZEUGE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_ANGEMIETETE_FAHRZEUGE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_CO2_FUSSABDRUCK_DATEIABLAGE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_CO2_FUSSABDRUCK, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK]: RoutingIDs.TAB_CO2_FUSSABDRUCK_DATEIABLAGE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_CO2_FUSSABDRUCK
    };
    public static ROUTE_MEHRSPRACHIGKEIT_NAVIGATION = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_MEHRSPRACHIGKEIT, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT]: RoutingIDs.TAB_MEHRSPRACHIGKEIT_NAVIGATION,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT
    };
    public static ROUTE_MEHRSPRACHIGKEIT_FORMULARE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_MEHRSPRACHIGKEIT, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT]: RoutingIDs.TAB_MEHRSPRACHIGKEIT_FORMULARE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT
    };
    public static ROUTE_MEHRSPRACHIGKEIT_STATISCHE_INHALTE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_MEHRSPRACHIGKEIT, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT]: RoutingIDs.TAB_MEHRSPRACHIGKEIT_STATISCHE_INHALTE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT
    };
    public static ROUTE_MEHRSPRACHIGKEIT_FAQ = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_MEHRSPRACHIGKEIT, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT]: RoutingIDs.TAB_MEHRSPRACHIGKEIT_FAQ,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT
    };
    public static ROUTE_MEHRSPRACHIGKEIT_GLOSSAR = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_MEHRSPRACHIGKEIT, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT]: RoutingIDs.TAB_MEHRSPRACHIGKEIT_GLOSSAR,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT
    };
    public static ROUTE_MEHRSPRACHIGKEIT_SYSTEMTEXTE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_MEHRSPRACHIGKEIT, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT]: RoutingIDs.TAB_MEHRSPRACHIGKEIT_SYSTEMTEXTE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT
    };
    public static ROUTE_MEHRSPRACHIGKEIT_ONLINE_HILFE = {
        ...RoutingIDs.ROUTE_DATENVERWALTUNG_MEHRSPRACHIGKEIT, hasSubs: false,
        [RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT]: RoutingIDs.TAB_MEHRSPRACHIGKEIT_ONLINE_HILFE,
        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_MEHRSPRACHIGKEIT
    };
    public static ROUTE_VERBAENDE_VERBANDSLISTE = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_VERBAENDE, hasSubs: false,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK_VERBAENDE]: RoutingIDs.TAB_VERBAENDE_VERBANDSLISTE,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK_VERBAENDE
    };
    public static ROUTE_VERBAENDE_VERBANDSZUORDNUNG = {
        ...RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_VERBAENDE, hasSubs: false,
        [RoutingIDs.TABS_UNTERNEHMENSDATENBANK_VERBAENDE]: RoutingIDs.TAB_VERBAENDE_VERBANDSZUORDNUNG,
        terminateOn: RoutingIDs.TABS_UNTERNEHMENSDATENBANK_VERBAENDE
    };
    public static ROUTE_ERZEUGUNGSDATEN_LASTDATEN_TABELLE = {
        ...RoutingIDs.ROUTE_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN, hasSubs: false,
        [RoutingIDs.TABS_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN]: RoutingIDs.TAB_ERZEUGUNGSDATEN_LASTDATEN_TABELLE,
        terminateOn: RoutingIDs.TABS_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN
    };
    public static ROUTE_ERZEUGUNGSDATEN_LASTDATEN_IMPORT = {
        ...RoutingIDs.ROUTE_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN, hasSubs: false,
        [RoutingIDs.TABS_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN]: RoutingIDs.TAB_ERZEUGUNGSDATEN_LASTDATEN_IMPORT,
        terminateOn: RoutingIDs.TABS_PV_TOOL_ERZEUGUNGSDATEN_LASTDATEN
    };
}
